import React, { useRef } from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';
import { showCustomDialog } from '../../helpers/DialogHelper';
import ChooseKeywords from '../../components/common/choose-keywords/ChooseKeywords';
import { t } from 'i18next';
import { KeywordResponse } from '../../models/monitor/KeywordResponse';
import { TagsResponse } from '../../models/tags/TagsResponse';
import { useUpdateProjectOptionsKeywords } from '../../api/hooks/project/options/useUpdateProjectOptionsKeywords';

const useChooseKeywords = ({ refreshProjects }: { refreshProjects: () => void }) => {
  const { refetchData } = useAccount();
  const { mutateAsync: updateProjectOptionsKeywords } = useUpdateProjectOptionsKeywords();
  const selectedKeywordsRef = useRef<string[]>([]);

  const updateKeywords = async (id: number, selectedKeywords: string[]) => {
    try {
      await updateProjectOptionsKeywords({
        projectId: id,
        keywords: selectedKeywords,
      });

      refreshProjects();
      refetchData();
    } catch (error) {
      console.error('Error updating keywords:', error);
    }
  };

  const confirmNewProjectKeywords = (
    projectId: number,
    getProjectName: () => string,
    keywordsResponse: KeywordResponse[],
    tags: TagsResponse[]
  ) => {
    showCustomDialog({
      header: t('selectBrandForAnalysis'),
      message: (
        <ChooseKeywords
          projectId={projectId}
          keywords={keywordsResponse}
          tags={tags}
          projectName={getProjectName().trim()}
          onChangeProject={(keywords: string[]) => (selectedKeywordsRef.current = keywords)}
        />
      ),
      acceptLabel: t('save'),
      rejectLabel: t('resetToDefault'),
      accept: () => updateKeywords(projectId, selectedKeywordsRef.current),
      reject: () => updateKeywords(projectId, []),
    });
  };

  return { confirmNewProjectKeywords };
};

export default useChooseKeywords;
